import { NSARouterMakerResult } from "namirasoft-account-react";
import { FilterItem, FilterItemOperator, SortItem } from 'namirasoft-core';
import { NamirasoftPaymentMetaDatabase, SubscriptionCancellationReasonRow, SubscriptionRow } from 'namirasoft-payment';
import { NSBanner, NSBoxRadio, NSBoxTextArea, NSButtonBlue, NSColumn, NSLabel, NSLoading, NSPanel, NSRow, NSSection, NSSpace, NSSpaceSizeType } from 'namirasoft-site-react';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { PaymentLayout } from "../PaymentLayout";
import { PaymentProps } from "../PaymentProps";
import { PaymentRoutes } from '../PaymentRoutes';

export interface SubscriptionCancellationPageProps extends NSARouterMakerResult, PaymentProps
{ }

export interface SubscriptionCancellationPageState
{
	subscription: SubscriptionRow | null;
	reasons: SubscriptionCancellationReasonRow[] | null;
	selected_reason: SubscriptionCancellationReasonRow | null;
	selected_explainations: { [cancellation_reason_id: string]: string };
}

function SubscriptionCancellationPage(props: SubscriptionCancellationPageProps)
{
	const { id } = useParams();

	let NSBoxTextArea_Other_Reason = useRef<NSBoxTextArea>(null);

	let [state, setState] = useState<SubscriptionCancellationPageState>({ subscription: null, reasons: [], selected_reason: null, selected_explainations: {} });

	useEffect(() =>
	{
		if (id)
		{
			props.servers.payment.subscription.Get(id).then(res =>
			{
				setState(pres => { return { ...pres, subscription: res } });
				let meta = new NamirasoftPaymentMetaDatabase(props.account.token_manager, props.notifier.onError);
				let filters = [
					new FilterItem(meta.tables.subscription_cancellation_reason, meta.tables.subscription_cancellation_reason.columns.product_id, false, FilterItemOperator.all.equals, res.product_id),
					new FilterItem(meta.tables.subscription_cancellation_reason, meta.tables.subscription_cancellation_reason.columns.sales_item_id, false, FilterItemOperator.all.equals, res.sales_item_id)
				];
				let sorts = [
					new SortItem(meta.tables.subscription_cancellation_reason, meta.tables.subscription_cancellation_reason.columns.order, true)
				];
				props.servers.payment.subscription_cancellation_reason.List(filters, null, null, sorts, null).then(res =>
				{
					setState(prev => { return { ...prev, reasons: res.rows } });
				}).catch(() => { });
			}).catch(() => { });
		}
		else
			props.url.redirect(PaymentRoutes.SubscriptionList(false, ""), {});
		// eslint-disable-next-line
	}, []);

	let onClick = async (onFinished: () => void) =>
	{
		try
		{
			if (id)
			{
				let cancellation_reason_id = state.selected_reason?.id ?? "";
				let cancellation_explaination = state.selected_explainations[cancellation_reason_id] ?? "";
				let res = await props.servers.payment.subscription.GetCancellationOffer(id, cancellation_reason_id);
				if (res.offer_id)
					props.url.redirect(PaymentRoutes.SubscriptionCancellationOffer(id, res.offer_id, cancellation_reason_id, true, ""), { cancellation_explaination });
				else
					props.url.redirect(PaymentRoutes.SubscriptionCancellationConfirmation(id, cancellation_reason_id, true, ""), { cancellation_explaination });
			}
		}
		catch
		{
			// The server already reported the error through the notifier.
		}
		finally
		{
			onFinished();
		}
	}

	if (!id)
		return <></>;

	if (!state.subscription || state.reasons == null)
		return <NSLoading></NSLoading>;

	return (
		<PaymentLayout {...props}
			action={{
				title: "Cancellation",
				description: "Select a reason for canceling your subscription from the provided list.",
				menus: {}
			}}
		>
			<NSSection>
				<NSColumn>
					<NSRow>
						<NSBanner
							imageLeft={{
								src: "https://static.namirasoft.com/image/concept/bot/upset.png",
								alt: "upset bot"
							}}
							imageRight={null}
							title={{
								text: "We're sorry to see you go!",
								style: {
									color: "rgba(255, 63, 63, 1)",
									fontWeight: "bold"
								}
							}}
						/>
					</NSRow>
				</NSColumn>
				<NSSpace size={NSSpaceSizeType.SMALL} />
				<NSPanel>
					<NSLabel
						title='Please let us know why you are canceling your subscription:'
					/>
					{
						state.reasons.map((reason) =>
							<>
								<NSBoxRadio
									id={reason.id}
									key={reason.id}
									required={false}
									title={reason.name}
									hideHeader
									onClicked={() => setState(prev => { return { ...prev, selected_reason: reason } })}
									checked={state.selected_reason?.id === reason.id}
									style={{ width: "100%" }}
								/>
								{
									(state.selected_reason?.id === reason.id && reason.needs_explaination) &&
									<NSBoxTextArea
										id={reason.id}
										key={reason.id}
										ref={NSBoxTextArea_Other_Reason}
										required={false}
										title='Please explain why you want to cancel.'
										placeholder='Explaination'
										rows={5}
										style={{ maxWidth: "100%", width: "100%" }}
										onChanged={(e) =>
										{
											let selected_explainations = state.selected_explainations;
											selected_explainations[reason.id] = e.getValue() ?? "";
											setState(prev => { return { ...prev, selected_explainations } });
										}}
									/>
								}
							</>
						)
					}
				</NSPanel>
				{
					(state.selected_reason && (!state.selected_reason.needs_explaination || state.selected_explainations[state.selected_reason.id]?.length > 0)) &&
					<>
						<NSSpace size={NSSpaceSizeType.NORMAL} />
						<NSButtonBlue
							title='Continue'
							onClick={{
								action: onClick,
								showLoading: true
							}}
						/>
					</>
				}
			</NSSection >
		</ PaymentLayout>

	);
}

export default SubscriptionCancellationPage;